import { NgModule } from '@angular/core'
import { OpenPanelMainContentLeftFeatureModule } from './open-panel-main-content-left/open-panel-main-content-left-feature.module'
import { OpenPanelMainContentRightFeatureModule } from './open-panel-main-content-right/open-panel-main-content-right-feature.module'
import { OpenPanelSubcomponentWrapperFeatureModule } from './open-panel-subcomponent-wrapper/open-panel-subcomponent-wrapper-feature.module'
import {
  OpenPanelMainContentFullWidthFeatureModule
} from './open-panel-main-content-full-width/open-panel-main-content-full-width-feature.module'

@NgModule({
  imports: [
    OpenPanelMainContentLeftFeatureModule,
    OpenPanelMainContentRightFeatureModule,
    OpenPanelMainContentFullWidthFeatureModule,
    OpenPanelSubcomponentWrapperFeatureModule,
  ]
})
export class OpenPanelRootModule {}
